module.exports = __webpack_public_path__ + "static/caveBear-2f3b33667e3e658cf0fc59987f49354f.jpg";